export default {
  submissions (state) {
    if (state.filter !== 'all') {
      return state.submissions.filter(submission => {
        return submission._id === state.filter
      })
    } else {
      return state.submissions
    }
  }
}
